import React from "react";
import withView from '../../../cmn/docAutomation/withView';
import DashViewByGroupRow from './DashViewByGroupRow';
import FormTitle from '../../../../library/form/components/FormTitle'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import FormInput from '../../../../library/form/components/FormInput';
import FormWrapper from '../../../../library/form/components/FormWrapper';
import { UiViewHeading, UiTitle, UiAction } from "../../../../library/layout/Index";

const DashViewByGroup = (props) => {
    const { formObject, sarasDnDManager, viewMap, groupData, groupKeys, groupDtId, deviceInfo,
        rowId, onFilterDateChange, onGroupDataChange, filterDate, groupHeight, groupClass } = props;

    const onDateChange = (date) => {
        let customAction = {actionId: "show", actionMessage:"Refreshing Dashboard",
                    actionParam: {tdoctyid:groupDtId, sview:"D",viewDataReload:"1",dshv_rowId:rowId,cSDate:date},
                    onSuccess: onSuccess }

        formObject.onFormAction(customAction, "", "");
    }

    const reloadData = (date) => {
        let customAction ={ actionId: "show", actionParam: {tdoctyid:groupDtId, sview:"D",viewDataReload:"1",dshv_rowId:rowId,cSDate:filterDate},
        actionMessage:"Refreshing Dashboard", onSuccess: onSuccess }

        formObject.onFormAction(customAction, "", "");
    }

    const onSuccess = (action, containerKey, rKey, headerKey, response) => {
        // console.log("view group check", rowId, response);

        if(onFilterDateChange && filterDate !== action.actionParam.cSDate) onFilterDateChange(action.actionParam.cSDate);
        onGroupDataChange(rowId, groupDtId, response.mainViewData);
    }

    if (!groupData || !groupKeys)
        return (null)

    return (
        <>
            <div className="phViewArea uiDashFixedHeader2 fixed-header-layer-2" >
                <UiViewHeading>
                    <UiTitle>
                        <span className="uiInline">
                            {!deviceInfo.activateMobileView ? <SarasTrans value="View: " /> : null} <FormTitle formObject={formObject} value='' />
                        </span>
                    </UiTitle>
                    <UiAction>
                        <div className="uiFlexBox">
                            <FormWrapper customWrapper="div" wrapperClass="uiFlexBox3" formObject={formObject} headerKey="actionButton" rowKey="" action={{ paramName: "calenderView" }} >
                                <span><SarasTrans value = "Date Filter"/></span>
                                <FormInput formObject={formObject} rowKey="" headerKey="actionButton" 
                                    className="uiCalendarFlatLook" onChange={onDateChange}
                                    action={{ InputType: "dp", paramName: "calenderView" }}
                                />
                            </FormWrapper>
                            <div>
                                <FormButton formObject={formObject} ksc="r" rowKey=""
                                    starIcon="refresh"
                                    onlyIcon={deviceInfo.activateMobileView ? 1 : 0}
                                    action={{ actionId: "show", actionParam: {tdoctyid:groupDtId, sview:"D",viewDataReload:"1",dshv_rowId:rowId,cSDate:filterDate},
                                    actionMessage:"Refreshing Dashboard", onSuccess: onSuccess }}
                                    className="uiActionButton uiSpacerH10" text={<SarasTrans value="Refresh View" />}>
                                </FormButton>
                            </div>
                        </div>
                    </UiAction>
                </UiViewHeading>
            </div>
            <div className="uiDashContentLayer1 fixed-content-layer-1" style={{position: "relative", top: "45px"}}>
                <div className="uiSecContents" id="dashGroupChoices" style={{ overflow: "visible" }}>
                        {
                            groupKeys.map((rowKey, index) => (
                                <DashViewByGroupRow formObject={formObject} rowKey={rowKey} 
                                    viewMap={viewMap}
                                    viewData={groupData.viewRows[rowKey]} key={index} dashRowId={rowId} 
                                    reloadData={reloadData} groupHeight={groupHeight} groupClass={groupClass} 
                                    sarasDnDManager={sarasDnDManager}
                                /> 
                            ))
                        }
                </div>
            </div>
        </>
    )
}

export default withView(DashViewByGroup, "dashViews", "")
